import { type ReactNode } from "react";

import clsx from "clsx";

import {
  ComboboxButton,
  ComboboxInput,
  PopoverButton,
} from "@headlessui/react";

interface Props {
  displayValue?: string;
  label: ReactNode;
  isDisabled?: boolean;
  open: boolean;
  variant: "popover" | "combobox";
}

export const AttributionButton = ({
  displayValue,
  isDisabled,
  label,
  open,
  variant,
}: Props) => {
  const content = (
    <>
      <span
        className={clsx("mr-1", {
          "text-primary": !open,
          "text-white": open,
        })}
      >
        {label}
      </span>
      <span className="truncate">{displayValue}</span>
    </>
  );

  const className = clsx(
    "text-xs button secondary-button h-7 py-0 px-2 flex items-center max-w-[120px] rounded-md",
    {
      "pointer-events-none text-disabled opacity-75": isDisabled,
    },
    {
      "bg-cosmic-4 border-cosmic-4 hover:bg-cosmic-3 hover:border-cosmic-3":
        !open,
      "bg-cosmic border-cosmic text-white": open,
    },
  );

  return (
    <>
      {variant === "popover" ? (
        <PopoverButton as="button" className={className}>
          {content}
        </PopoverButton>
      ) : (
        <ComboboxButton as="button" className={className}>
          <ComboboxInput value={displayValue} className="w-0" />
          {content}
        </ComboboxButton>
      )}
    </>
  );
};
